import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-7" }

import {withDefaults} from "vue";

  
export default /*#__PURE__*/_defineComponent({
  props: {
    sectionName: null,
    bgColor: { default: 'bg-white' },
    textColor: { default: 'text-orange' }
  },
  setup(__props: any) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["font-semibold p-10 text-lg", __props.textColor])
    }, _toDisplayString(__props.sectionName) + " : ", 3),
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col items-center justify-center", __props.bgColor])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})